import { render, staticRenderFns } from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=template&id=1523aeb4&"
import script from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderProfileDropdownMobile.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports